import { vModelText as _vModelText, normalizeClass as _normalizeClass, createElementVNode as _createElementVNode, withDirectives as _withDirectives, toDisplayString as _toDisplayString, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode, Fragment as _Fragment } from "vue"

const _hoisted_1 = { class: "input-group" }
const _hoisted_2 = {
  key: 0,
  class: "input-group-text"
}
const _hoisted_3 = {
  key: 1,
  class: "invalid-feedback d-block"
}

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _withDirectives(_createElementVNode("input", {
      "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.numberValueRaw) = $event)),
      type: "text",
      class: _normalizeClass(["form-control", {'is-invalid': _ctx.isInvalid()}])
    }, null, 2), [
      [_vModelText, _ctx.numberValueRaw]
    ]),
    (_ctx.unit !== null)
      ? (_openBlock(), _createElementBlock("div", _hoisted_2, _toDisplayString(_ctx.unit), 1))
      : _createCommentVNode("", true),
    (_ctx.isInvalid())
      ? (_openBlock(), _createElementBlock("div", _hoisted_3, [
          (_ctx.numberValueRaw === '')
            ? (_openBlock(), _createElementBlock(_Fragment, { key: 0 }, [
                _createTextVNode(_toDisplayString(_ctx.$t('form.errors.parameterNotFilled', [_ctx.label])), 1)
              ], 64))
            : (isNaN(_ctx.getValue()))
              ? (_openBlock(), _createElementBlock(_Fragment, { key: 1 }, [
                  _createTextVNode(_toDisplayString(_ctx.$t('form.errors.notANumber')), 1)
                ], 64))
              : (_ctx.getValue() < _ctx.min)
                ? (_openBlock(), _createElementBlock(_Fragment, { key: 2 }, [
                    _createTextVNode(_toDisplayString(_ctx.$t('form.errors.mustBeLargerThan', [_ctx.label, _ctx.min])), 1)
                  ], 64))
                : _createCommentVNode("", true)
        ]))
      : _createCommentVNode("", true)
  ]))
}